export default {
	director: {
		jobName: "ディレクター",
		first: {
			visual: "director",
			catch: "自分のコンサル力、試してみませんか？",
			read: "LYZONが求めるディレクターは、アタマとカラダをフルに使う営業スタイルです。<br>提案力に自信がある人、さらに提案力を伸ばしたい人、新しいサービスにどんどんチャレンジして、自分の能力や経験値を高めていきませんか？",
		},
		new: {
			recruiting: true,
			work: "<span>(1)サイト構築のディレクション</span><br>主にコーポレートサイトやプロモーションサイトを構築しています。<br>・お客様との調整業務（メール、電話、打ち合わせ等）<br>・要望ヒアリング、要件定義<br>・スケジュール策定、進行管理<br>・情報設計（サイトマップ、ワイヤーフレーム作成）<br>・社内デザイナー・エンジニアとの調整業務<br>・品質チェック<br><span>(2)サイト運用</span><br>・定期的なお客様との打ち合わせ<br>・コンテンツ更新に関する調整業務<br>・デザイン・システム改修に関する調整業務<br>・サイト改善企画の提案<br><span>(3)WEB マーケティング / コンサルティング</span><br>・リスティング広告、SEO、SNS などからの流入対策<br>・導線設計<br>・メールマーケティング、CRM 連動提案<br><span>(4)提案営業</span><br>・お客様のニーズのヒアリング<br>・ソリューション提案<br>・見積書の作成",
			develop:
				"・JIRA（プロジェクト管理）、Slack（チャットコミュニケーションツール）<br>・Bitbucket/Git（バージョン管理）",
			salary: "月給22万円",
			qualification: false,
			time: "9:00～18:00<br>フレックスタイム制導入(コアタイム/月曜日 9:00～15:00、火～金曜日　10:30～16:00)",
		},
		mid: {
			recruiting: true,
			work: "<span>(1)サイト構築のディレクション</span><br>主にコーポレートサイトやプロモーションサイトを構築しています。<br>・お客様との調整業務（メール、電話、打ち合わせ等）<br>・要望ヒアリング、要件定義<br>・スケジュール策定、進行管理<br>・情報設計（サイトマップ、ワイヤーフレーム作成）<br>・社内デザイナー・エンジニアとの調整業務<br>・品質チェック<br><span>(2)サイト運用</span><br>・定期的なお客様との打ち合わせ<br>・コンテンツ更新に関する調整業務<br>・デザイン・システム改修に関する調整業務<br>・サイト改善企画の提案<br><span>(3)WEB マーケティング / コンサルティング</span><br>・リスティング広告、SEO、SNS などからの流入対策<br>・導線設計<br>・メールマーケティング、CRM 連動提案<br><span>(4)提案営業</span><br>・お客様のニーズのヒアリング<br>・ソリューション提案<br>・見積書の作成",
			develop:
				"・JIRA（プロジェクト管理）、Slack（チャットコミュニケーションツール）<br>・Bitbucket/Git（バージョン管理）",
			salary: "405万円〜607万円<br>※裁量労働制導入につき、月35時間分のみなし残業代を給与に含めて支給します。<br>※経験、スキルを考慮の上、当社規定により優遇します。<br>※試用期間は入社後3ヶ月間です。給与・待遇に差異はありません。",
			qualification:
				"<span>（1）必須要件</span><br>・社会人経験5年以上<br>・Web業界、IT業界、アプリ業界での就業経験2年以上（例：Webライター、サイト運営なども可）<br>・根気強く、社内外の人と接するコミュニケーション力（例：顧客との交渉経験など）<br><span>（2）歓迎要件</span><br>・業務推進力がある<br>・顧客と社内の橋渡し役として各種調整ができる<br>・未知のものに触れることに抵抗が無い（職業柄、未知のものに触れることが前提）<br>・プロジェクト進行管理経験",
			time: "9:00～18:00",
		},
		formParam: "希望職種=Webディレクター",
	},
	backend: {
		jobName: "エンジニア",
		first: {
			visual: "engineer",
			catch: "最新技術を駆使したWebサイト構築",
			read: "閲覧するユーザーに合わせてコンテンツを出し分けする機能を兼ね揃えたプラットフォームであるSitecore。さらにCRMや商品DBと連携させることでSitecoreのデジタルマーケティング機能は大幅にグレードアップし、最先端のWebサイトを構築することができます。<br>このようなサイトのテンプレートや外部システム連携の設計、開発を行える人材を求めています。",
		},
		new: {
			recruiting: true,
			work: "<span>(1)CMSを利用したWebサイト構築</span><br>・Sitecore(高機能CMS)やWordPress、Drupal(オープンソースCMS)を活用したサイト構築<br>・CMSのテンプレートやコンポーネントの設計・開発<br><span>(2)Webアプリケーションの設計・開発</span><br>・ASP.NET MVC（C#）やReact、TypeScriptを使用した業務用Webアプリケーション開発<br>・WebAPIを利用した外部システム連携機能開発<br><span>(3)Webサイトのインフラ設計・構築</span><br>・クラウド（Azure/AWS）を利用したサーバやネットワーク構築",
			develop:
				"言語：C# / PHP<br>フレームワーク：ASP.NET MVC / ASP.NET Web Form / Vue.js / jQuery<br>インフラ：Azure / AWS<br>ミドルウェア：IIS / SQL Server / Solr / Apache / MySQL / Docker / AzureDevOps / Jenkins / webpack<br>開発マシン：Windows / デュアルディスプレイ / core i7 / メモリ16G / SSD（参考）<br>その他：Git / Visual Studio / Visual Studio Code / JIRA / Backlog / Slack / Office365",
			salary: "月給22万円",
			qualification: false,
			time: "10：00～19：00 ※週明け曜日のみ、全体朝礼のため9：00始業<br>フレックスタイム制導入(コアタイム/月曜日 9:00～15:00、火～金曜日　10:30～16:00)",
		},
		mid: {
			recruiting: true,
			work: "<span>(1)CMSを利用したWebサイト構築</span><br>・Sitecore(高機能CMS)やWordPress、Drupal(オープンソースCMS)を活用したサイト構築<br>・CMSのテンプレートやコンポーネントの設計・開発<br><span>(2)Webアプリケーションの設計・開発</span><br>・ASP.NET MVC（C#）やReact、TypeScriptを使用した業務用Webアプリケーション開発<br>・WebAPIを利用した外部システム連携機能開発<br></br><span>(3)Webサイトのインフラ設計・構築</span><br>・クラウド（Azure/AWS）を利用したサーバやネットワーク構築",
			develop:
				"言語：C# / PHP<br>フレームワーク：ASP.NET MVC / ASP.NET Web Form / Vue.js / jQuery<br>インフラ：Azure / AWS<br>ミドルウェア：IIS / SQL Server / Solr / Apache / MySQL / Docker / AzureDevOps / Jenkins / webpack<br>開発マシン：Windows / デュアルディスプレイ / core i7 / メモリ16G / SSD（参考）<br>その他：Git / Visual Studio / Visual Studio Code / JIRA / Backlog / Slack / Office365",
			salary: "メンバークラス採用：年収405万～607万<br>管理職クラス採用：年収607万～742万<br><br>※採用ポジションによって給与は異なります。<br>※裁量労働制導入につき、月35時間分のみなし残業代を給与に含めて支給します。<br>※経験、スキルを考慮の上、当社規定により優遇します。<br>※試用期間は入社後3ヶ月間です。給与・待遇に差異はありません。",
			qualification:
				"<span>（1）必須要件</span><br>メンバークラス：<br>・基本設計以降の経験が1年以上（言語不問）<br>・Webアプリケーションの実装経験が2年以上<br>※オブジェクト指向系プログラミング言語の経験。特に言語は問わない（Java、C#、PHP、Ruby等）<br><br>管理職クラス：<br>・Webアプリケーションの設計・実装経験が5年以上<br>※オブジェクト指向系プログラミング言語の経験。特に言語は問わない（Java、C#、PHP、Ruby等）<br>・リーダー経験（3人以上）2年以上：進捗・タスク管理、教育などのメンバー管理<br><span>（2）歓迎要件</span><br>メンバークラス：<br>・クラウドの経験（Azure、AWS）<br>・顧客との折衝経験<br>・React, Vue, TypeScriptなどのjavascriptフレームワークを使用した実装経験<br>・Microsoft系の経験（Azure、.NET、C#、SQL Server等）、CMSの経験<br><br>管理職クラス：<br>・1,000万円以上の案件の要件定義・基本設計の経験<br>・顧客との折衝経験<br>・クラウドの経験（Azure、AWS）",
			time: "10：00～19：00 ※週明け曜日のみ、全体朝礼のため9：00始業",
		},
		formParam: "希望職種=Webエンジニア",
	},
	infra: {
		jobName: "インフラエンジニア",
		first: {
			visual: "infra",
			catch: "Webサイトを支えるインフラ構築",
			read: "ECサイトやポータルサイトなど、様々な役割を担うWebサイトの基盤となるインフラの構築・保守をお任せします。<br>AWSやAzureを利用してコストパフォーマンスに優れたインフラ構築ができる人材を募集しています。",
		},
		new: {
			recruiting: false,
			work: "<span>(1)Webサイトのインフラ設計・構築</span><br>Web サイトを構築・運営する上で可用性やパフォーマンス、セキュリティを意識したサーバ・ネットワーク環境の設計・構築を行っていただきます。<br><span>(2)Webサイトのインフラ運用</span><br>既存クライアントの Webサイトにおけるインフラ運用を行っていただきます。<br>大規模のサイトにおける基盤の設計・構築を Azure や AWS を利用して構築を行います。<br>VM や EC2 などの IaaS に限らず、AppService や SQL データベース などの PaaS の取り組みも行っており、ローコスト・ハイクオリティを実現しています。<br>また、サイトに欠かせない検索機能のエンジンとして Solr や Azure Search などを利用しているため、幅広い知識を身に付けることができ、将来を見据えたキャリア構築が可能です。<br>また、自社内開発100%でディレクターやデザイナーとの距離が近く、連携が取りやすい環境です。",
			develop:
				"・JIRA（プロジェクト管理）、Slack（チャットコミュニケーションツール）<br>・Bitbucket/Git（バージョン管理）<br>・JavaScript（Vue.js）、テスト自動化（Selenium）、継続的インテグレーション（jenkins）<br>・C#（ASP.NET MVC、.NET Framework 、LINQ、LightSpeed ORMなど）を中心に開発<br>・AWS、Azure<br>・利用技術など：ASP、SQL",
			salary: "月給22万円",
			qualification: "学歴不問",
			time: "月曜日9:00～18:00、火～金曜日10:00～19:00　フレックスタイム制導入<br />【コアタイム】月曜日9：00～15：00、火～金曜日10：30～16：00",
		},
		mid: {
			recruiting: false,
			work: "スキルに合わせて、下記のような業務を行っていただきます。<br><span>(1)Webサイトのインフラ設計・構築</span><br>Web サイトを構築・運営する上で可用性やパフォーマンス、セキュリティを意識したサーバ・ネットワーク環境の設計・構築を行っていただきます。<br>クライアントにあったインフラ設計をし、クラウド（Azure/AWS）を利用してサーバやネットワークを構築していただきます。<br>VM や EC2 などの IaaS に限らず、AppService や SQL データベース などの PaaS の取り組みも行っており、ローコスト・ハイクオリティを実現しています。<br><span>(2)サイトコアのインストール、設定</span><br>ＣＭＳパッケージであるサイトコアのインストール設定を行っていただきます。インフラエンジニアであってもＷｅｂアプリケーションの役割を理解して適切に設計することが求められます。<br>※ポイント<br>・1サイトあたりサーバ数台～数十台の、大規模Webサーバ構築。<br>・Azure、AWSでのクラウドでの構築・運用がメイン（オンプレもゼロではない）<br>・Windows系がメイン。<br>・パフォーマンス、セキュリティ、高可用性を意識した設計。<br>・監視、バックアップ、冗長化、グローバルを意識した構成など様々な経験が詰める。<br>・デプロイメントスロット、オートスケールの設定なども対応が必要。<br>・要件定義や設計からインフラの改善運用まで対応。<br>・インフラ設計はもちろん、単純な監視のような保守だけでなく、提案ベースのインフラの改善を行う。<br>・インフラとアプリケーションの境界は曖昧。インフラエンジニアであっても、アプリケーションのことを理解してもらう必要がある。弊社のサーバサイドエンジニアもインフラが強いメンバーも多く、相互に連携して、インフラ設計構築を行う。<br>・経験が少なくとも、成長できる場がある。",
			develop:
				"・言語：特になし。Azure / AWSが利用できること<br>・インフラ：Azure / AWS<br>・ミドルウェア：IIS / SQL Server / Solr / Docker / kubernetes / AzureDevOps  / Jenkins / webpack / （Apache / MySQL）<br>　※Windows系のサーバがメインになります。Linuxは少ないです。<br>　※Solr / CI(Jenkins)の構築経験などがあれば高く評価します。<br>・開発マシン：Windows / デュアルディスプレイ / core i7 / メモリ16G / SSD（参考）<br>・その他：Git / Visual Studio / Visual Studio Code / JIRA / Backlog / Slack / Office365",
			salary: "月給28万円 ～ 70万円<br>※社会人経験3年目以降：基本給+30時間分のみなし残業代を月給として支給<br>※経験、スキルを考慮の上、当社規定により優遇いたします<br>【研修・試用期間】<br>試用期間3ヶ月※スキル・経験に応じて変更あり (給与・待遇に差異はありません)",
			qualification:
				"<span>(1)必須スキル</span><br>・インフラ設計構築の実績<br>　特にWebサーバー（Windows/IISでの構築）の設計構築の実績<br>　特にAWS、Azureの構築運用経験<br>・Windows Server/IIS/SQLserverの構築、運用経験<br>・AWS、Azureの構築、運用経験<br>上記のどれかの経験が1年以上<br>※クラウドの経験などが少なくても、成長する機会が提供可能です。<span>(2)以下の経験・スキルがあると尚可</span><br>・Webアプリケーションの開発経験（2年程度）<br>　C#/Java/PHP等のサーバーサイド言語での開発経験があること。<br>　サーバサイドエンジニアからインフラエンジニアへのコンバートも歓迎<br>・Visual Studio/C#/ASP.NET MVCを使用した開発経験<br>・CMSを使ったサイト構築の経験<br><span>(3)その他</span><br>・Webアプリケーションの設計、実装ができる。<br>・仕様書、設計書等のドキュメントが起こせる。<br>・プロジェクトリーダーの経験がある。",
			time: "月曜日 9:00～18:00、火～金曜日 10:00～19:00（一部裁量労働制 導入）",
		},
		formParam: "希望職種=インフラエンジニア",
	},
	designer: {
		jobName: "デザイナー",
		first: {
			visual: "designer",
			catch: "心を動かすデザインでゴールへ導く",
			read: "LYZONは大手企業様からの引き合いも多く、大手クライアントサイトのデザインやコーディングをメインで担当する機会に恵まれています。また、制作から運用まで一貫して担当していくので、双方のノウハウが蓄積でき、新しい技術に積極的に挑戦することも可能です。<br>思わず使いたくなるような「デザイン力」と、一緒に「成長したい思い」のある方を募集しています。",
		},
		new: {
			recruiting: true,
			work: "<span>(1)サイト運用・構築</span><br>・UIUXデザイン（XD/Photoshop/Illustrator)<br>・コーディング（html/CSS/Sass/pug）<br>・フロントエンド（JavaScript/TypeScript）<br>・バナー制作<br><span>(2)自社マーケティング関連</span><br>・自社サイトコンテンツ改善によるWebマーケティング業務<br>・バナー制作<br><span>(3)動画テンプレートデザイン業務</span><br>・動画制作におけるテンプレートデザイン",
			develop:
				"・JIRA（プロジェクト管理）、Slack（チャットコミュニケーションツール）<br>・Bitbucket/Git（バージョン管理）<br>・Adobe Creative Cloud<br>・gulp/タスクランナー/pug/scss<br>・JavaScript",
			salary: "月給22万円",
			qualification: false,
			time: "10：00～19：00 ※週明け曜日のみ、全体朝礼のため9：00始業<br>フレックスタイム制導入(コアタイム/月曜日 9:00～15:00、火～金曜日　10:30～16:00)",
		},
		mid: {
			recruiting: false,
			work: "<span>(1)サイト制作</span><br>Webサイトリニューアルや新規構築案件、ディレクター・エンジニアと一緒になって構築を行っていただきます。<br><span>(2)サイト運用業務</span><br>細部の修正から、新規コンテンツ制作などを行っていただきます。<br>お客様のニーズに合わせWebデザイン、コーディング、jQueryやJavascriptなどをスキルに応じてお任せします。",
			develop:
				"・JIRA（プロジェクト管理）、Slack（チャットコミュニケーションツール）<br>・Bitbucket/Git（バージョン管理）<br>・Adobe Creative Cloud<br>・gulp/タスクランナー/pug/scss<br>・JavaScript",
			salary: "400万円〜550万円<br>※経験、スキルを考慮の上、当社規定により優遇いたします<br>【研修・試用期間】<br>試用期間3ヶ月※スキル・経験に応じて変更あり (給与・待遇に差異はありません)",
			qualification:
				"・Photoshop/Illustrator/XDを使ってデザインができる方<br>・HTML/CSSの実務経験がある方<br>・JavaScript/jQueryの実務経験がある方<br>・デザイナーとしての実務経験が3年以上ある方<br>・CMSを利用したことがある方(運用など)<br>【歓迎するスキル】<br>・CMSの構築経験のある方<br>・UI、UXデザインの経験のある方<br>・Sass/pugの使用経験がある方<br>・TypeScriptの使用経験がある方<br>・gulp/タスクランナーの使用経験がある方<br>・Gitを使ったバージョン管理経験のある方",
			time: "月曜日 9:00～18:00、火～金曜日 10:00～19:00（一部裁量労働制 導入）",
		},
		formParam: "希望職種=Webデザイナー",
	},
	frontend: {
		jobName: "フロントエンドエンジニア",
		first: {
			visual: "frontend",
			catch: "Sitecoreサイト構築やアプリケーション開発",
			read: "Sitecoreサイト構築やWebアプリケーションの構築を行います。クライアントサイドが得意、サーバサイドが得意、新技術を学びたい意欲がある人材を募集しています。",
		},
		new: {
			recruiting: false,
			work: "<span>(1)Sitecore(CMS)のテンプレート設計・開発によるサイト構築</span><br>同社では、Sitecore(高機能CMS)を活用したサイト構築を行っています。同業務ではCMSの機能を理解し、サーバーサイドエンジニアと連携を図りながらUIや非同期周りの実装を担当します。その他、MovableType、PowerCMS、Concrete5、WordPressの実績があります。<br><span>(2)ASP.NET MVCを用いたスクラッチ開発</span><br>ASP.NET MVCを用いたWebアプリケーションの構築を行います。CMSに慣れていない方やサーバーサイドの経験がある方は、追加開発を担当しながらC#およびASP.NET MVCへの理解を深めていくことが可能です。<br><span>(3)その他業務</span><br>要件定義を行います。クライアントにヒアリングを行い、必要な機能等を選定・提案し、決定した要件を資料にまとめていきます。<br>当社が手がけているシステムは常にモジュール化を意識して開発しており、新しいお客様に合わせてカスタマイズする部分に集中することで、ローコスト、ハイクオリティを実現しています。<br>また、当社ではサービスの差別化を図るべく、サイト構築のみならず運用にも力を入れ、お客様の満足度を上げるためのカスタマイズを行っています。<br>業務を通じて、最先端の技術(AI、AWS、Azure、Solrなど)に触れることによって知識を磨くことができ、エンジニアとしての幅を広げることが可能です。<br>また、自社内開発100%でディレクターやデザイナーとの距離が近く、連携が取りやすい環境です。",
			develop:
				"・JIRA(プロジェクト管理)、Slack(チャットコミュニケーションツール)<br>・Bitbucket/Git(バージョン管理)<br>・JavaScript(Vue.js、React、AngularJS)、テスト自動化(Selenium)、継続的インテグレーション(jenkins)<br>・C#(ASP.NET MVC、.NET Framework 、LINQ、LightSpeed ORMなど)を中心に開発<br>・AWS、Azure",
			salary: "月給22万円",
			qualification: "学歴不問",
			time: "月曜日9:00～18:00、火～金曜日10:00～19:00　フレックスタイム制導入<br />【コアタイム】月曜日9：00～15：00、火～金曜日10：30～16：00",
		},
		mid: {
			recruiting: false,
			work: "スキルに合わせて、下記のような業務を行っていただきます。<br><span>(1)Webアプリケーションのフロントエンド開発</span><br>同社では、Sitecore(高機能CMS)を活用したサイト構築を行っています。<br>弊社のサーバーサイドエンジニアと連携を図りながらUIや非同期通信周りの実装を担当していただきます。<br>その他WordPress、MovableType、PowerCMSの実績があります。<br><span>(2)ASP.NET MVC（C#）を使用したWebアプリケーションの設計・開発</span><br>サーバーサイド開発の経験がある方や、興味がある方はC#やASP.NET MVCを学習しながら<br>徐々にWebアプリケーション開発業務に携わっていただくことが可能です。<br><span>(3)その他</span><br>クライアントにディレクターと共にヒアリングを行い、必要な機能等を選定し、資料を作成していただきます。",
			develop:
				"・言語：JavaScript / Babel / TypeScript / C#<br>・フレームワーク：Vue.js / jQuery等<br>・ミドルウェア：IIS / SQL Server / Solr / Apache / MySQL / Docker / AzureDevOps  / Jenkins / webpack<br>・開発マシン：Windows / デュアルディスプレイ / core i7 / メモリ16G / SSD（参考）<br>・その他：Git / Visual Studio Code / Visual Studio / JIRA / Backlog / Slack / Office365",
			salary: "月給28万円 ～ 70万円<br>※社会人経験3年目以降：基本給+30時間分のみなし残業代を月給として支給<br>※経験、スキルを考慮の上、当社規定により優遇いたします<br>【研修・試用期間】<br>試用期間3ヶ月※スキル・経験に応じて変更あり (給与・待遇に差異はありません)",
			qualification:
				"<span>(1)必須スキル</span><br>・フロントエンドエンジニアとしての開発経験（2年程度）<br>　HTML，CSS，JavaScriptよるソース・ファイル設計 / コーディング経験<br>・サーバーサイドプログラミングの基礎知識（C# / Java / PHP等）<br><span>(2)以下の経験・スキルがあると尚可</span><br>・サーバーサイドエンジニアとしての開発経験<br>・パッケージマネージャーを用いた開発経験(npm / yarn)<br>・フロントエンドフレームワークを用いた開発経験(Vue.js / AngularJS / React等)<br>・ビルトツールを用いた開発経験(webpack / Browserify等)<br>・JavaScript代替言語を用いた開発経験(Babel / TypeScript等)<br><span>(3)その他</span><br>・仕様書・設計書等のドキュメントが起こせる。<br>・WebAPIの設計・実装ができる。<br>・要件定義（お客様の）ヒアリングができる。",
			time: "月曜日 9:00～18:00、火～金曜日 10:00～19:00（一部裁量労働制 導入）",
		},
		formParam: "希望職種=フロントエンドエンジニア",
	},
	sales: {
		jobName: "企画提案営業",
		first: {
			visual: "sales",
			catch: "アイデアと提案力で大手企業を動かす",
			read: "今のLYZON営業が求めるものは、まさにこれから作り上げていく営業組織の中核を担う人材です。<br>営業スキルやWebの知識があることも重要ですが、何より重要なのは幅広い知識を貪欲に吸収する「旺盛な好奇心」です。<br>一緒に最先端の技術に関わりながら、自分の能力を高めていきませんか？",
		},
		new: {
			recruiting: true,
			work: "大きく分けて4つの業務を各自分担して対応しています。<br><span>(1)企画提案活動</span><br>・お客様との調整業務（メール、電話、打ち合わせ、フォロー）<br>・書類作成（見積書、契約書、提案書など）<br>・議事録対応<br>・クロージング対応<br>・社内ディレクターやエンジニアとの連携<br><span>(2)既存顧客やグループ企業に対する営業活動</span><br>・追加契約提案<br>・定期的なお客様との打ち合わせ<br>・継続的なリレーション構築と維持<br><span>(3)自社マーケティング関連</span><br>・コーポレートサイトやSitecore PRサイトの改善<br>・コンテンツ構成の企画<br>・Sitecore主催イベントのスポンサー準備と参加<br><span>(4)ビジネスパートナーへの営業活動</span><br>・Sitecoreパートナーとの協業対応<br>・Sitecoreパートナー以外のビジネスパートナーとの協業対応（SIerなど）",
			develop:
				"・JIRA（プロジェクト管理）、Slack（チャットコミュニケーションツール）<br>・Bitbucket/Git（バージョン管理）",
			salary: "月給22万円",
			qualification: false,
			time: "9：00～18：00<br>フレックスタイム制導入(コアタイム/月曜日 9:00～15:00、火～金曜日　10:30～16:00)",
		},
		mid: {
			recruiting: true,
			work: "大きく分けて4つの業務を各自分担して対応しています。<br><span>(1)企画提案活動</span><br>・お客様との調整業務（メール、電話、打ち合わせ、フォロー）<br>・書類作成（見積書、契約書、提案書など）<br>・議事録対応<br>・ソリューション提案<br>・社内ディレクターやエンジニアとの連携<br><span>(2)既存顧客やグループ企業に対する営業活動</span><br>・お客様のニーズのヒアリング<br>・追加契約提案<br>・定期的なお客様との打ち合わせ<br><span>(3)自社マーケティング関連</span><br>・コーポレートサイトやSitecore PRサイトの改善<br>・コンテンツ構成の企画<br>・Sitecore主催イベントの参加および出展内容の企画<br><span>(4)ビジネスパートナーへの営業活動</span><br>・Sitecoreパートナーとの協業対応<br>・Sitecoreパートナー以外のビジネスパートナーとの協業対応（SIerなど）",
			develop:
				"・JIRA（プロジェクト管理）、Slack（チャットコミュニケーションツール）<br>・Bitbucket/Git（バージョン管理）",
			salary: "年収405万～607万<br>※経験、スキルを考慮の上、当社規定により優遇します。<br>※試用期間は入社後3ヶ月間です。給与・待遇に差異はありません。",
			qualification:
				"<span>（1）必須要件</span><br>・コミュニケーション能力がある方（人との会話がスムーズにできるレベル）<br>・アンテナをはって新しいことを受け入れられる方（Web商材のため情報の移り変わりが早い）<br>・PCの基本操作スキル（Word、Excel、PowerPoint）<br><span>（2）歓迎要件</span><br>・PC操作が得意<br>・メールや電話対応が得意",
			time: "9：00～18：00<br>フレックスタイム制導入(コアタイム/月曜日 9:00～15:00、火～金曜日　10:30～16:00)",
		},
		formParam: "希望職種=企画提案営業",
	},
	accounting: {
		jobName: "経営企画室",
		first: {
			visual: "accounting",
			catch: "普通の事務職とは一味違います",
			read: "経営企画室って何をやる職種なんだろう？その業務内容は多岐にわたります。自ら企画を作成したり、社長と共に社内改善につとめます。普通の事務職ではなく、幅広い業務に携わりたいという方を、お待ちしております。",
		},
		new: {
			recruiting: false,
			work: "<span>(1)バックオフィスのオペレーション</span><br>バックオフィス業務を各自分担しながら対応しています。<br>フローの見直しや自動化システムを取り入れるなど、業務効率化を図りながら行います。<br>総務：社内環境の整備、社内ルールの周知、来客対応、電話対応、郵送対応、備品の在庫管理・発注<br>労務：規程整備、給与計算、勤怠管理、雇用契約書の管理、社員からの各種相談対応、社労士とのやり取り、定例MTGの参加<br>経理：会計管理、納税対応、契約書類の保管、売上・請求管理、入金、会計士とのやり取り、定例MTGの参加<br>人事：各種採用活動、採用イベントの企画運営、応募者や採用会社とのやり取り、定例MTGの参加<br>法務：弁護士へのリーガルチェック依頼、電子署名の対応<br><span>(2)企画立案</span><br>業務改善または社内改善のために企画の立案から実施を分担して対応します。<br>例：社内懇親イベント企画、社内システムの運用見直し、インターンシップ企画<br>・改善点の洗い出し<br>・改善案の検討<br>・企画書の作成<br>・実施スケジュールの検討<br>・社内ディレクターやエンジニアとの連携や相談<br>・物品の調達<br>・当日の運営対応",
			develop:
				"・JIRA（プロジェクト管理）、Slack（チャットコミュニケーションツール）<br>・Bitbucket/Git（バージョン管理）",
			salary: "月給22万円",
			qualification: false,
			time: "9：00～18：00<br>フレックスタイム制導入(コアタイム/月曜日 9:00～15:00、火～金曜日　10:30～16:00)",
		},
		mid: {
			recruiting: false,
			work: "<span>(1)バックオフィスまわりの対応</span><br>総務、労務、経理、会計、人事といった一般事務の業務を幅広く対応します。<br>メイン担当の配属先は、入社後に決定します。<br><span>(2)企画立案や提案</span><br>上記のオペレーション業務だけでなく、会社の改善のために企画書を作成して、実行していく仕事もあります。<br>また、代表の指示によってプロジェクトが発足することもあるので、業務内容は多岐にわたります。",
			develop: "Slack（チャットコミュニケーションツール）",
			salary: "",
			qualification: "",
			time: "月曜日 9:00～18:00、火～金曜日 10:00～19:00（一部裁量労働制 導入）",
		},
		formParam: "希望職種=経営企画室",
	},
	video: {
		jobName: "動画クリエイター",
		first: {
			visual: "video",
			catch: "映像の力で最高のブランディングを",
			read: "動画サービス拡大に伴い、動画専任のメンバーを募集します。<br>新しい技術はメンバーの判断で、積極的に導入できる環境です。主体性を持って行動でき、新しいことに挑戦できる方をお待ちしています。",
		},
		new: {
			recruiting: false,
		},
		mid: {
			recruiting: false,
			work: "<span>動画コンテンツの企画・作成</span><br>・会社紹介動画や、マーケティング動画の制作業務全般。（制作・編集）<br>・他にも、企画の立案・ディレクション業務・ストーリーボードの作成もお任せします。<br>社内プロジェクトの一環である動画プロジェクトメンバーとして、企業向けの会社紹介動画や採用動画、マーケティング動画などの制作業務全般をお任せします。<br>特にモーショングラフィックスに強いメンバーを募集しています。<br>希望に応じて動画編集業務だけではなく、企画・提案・シナリオ作成などディレクション業務にも関わることができます。",
			develop:
				"・Adobe Premiere/After Effects<br>・Windows PC<br>・デュアルモニター<br>・JIRA(プロジェクト管理)<br>・Slack(チャットコミュニケーションツール)<br>【機材】<br>・カメラ（Sony α7sⅢ、Canon EOS 80D、Panasonic LUMIX DMC-FZH1、GoPro HERO9 Black）<br>・Wireless マイク（Sony UWP-D21）<br>・ジンバル（DJI RS 2）",
			salary: "月給25万円 ～ 42万円<br>※社会人経験3年目以降：基本給+35時間分のみなし残業代を月給として支給<br>※経験、スキルを考慮の上、当社規定により優遇いたします<br>【研修・試用期間】<br>試用期間3ヶ月※スキル・経験に応じて変更あり (給与・待遇に差異はありません)",
			qualification:
				"・動画コンテンツ制作の実務経験（Premiere、After Effects など動画編集ソフトを使用した制作経験（企画・構成・撮影など）<br>・動画メディア・サービス・アプリでの企画・ディレクション業務<br>・動画コンテンツ企画の実務経験（ストーリーボード作成経験など）<br>・Photoshop・Illustratorを使った画像素材の制作経験<br>※ポートフォリオ提出可能な方<br>【歓迎するスキル】<br>・動画撮影/ライブ配信経験<br>・アニメーション制作経験<br>・UI/UXデザイン経験",
			time: "月曜日 9:00～18:00、火～金曜日 10:00～19:00（一部裁量労働制 導入）",
		},
		formParam: "希望職種=動画クリエイター",
	},
};



// WEBPACK FOOTER //
// ./src/json/recruitments.js